// extracted by mini-css-extract-plugin
export default {"header":"index_header_4zLX5 clearfix","logo":"index_logo_Fx9JJ"};